// посвящается safari
import {useEffect} from 'react';
import {isBrowserContext} from 'core/helpers';

let activeLocks = 0;
let savedScrollY = 0;
let previousBodyPosition = '';
let previousBodyTop = '';
let previousBodyWidth = '';
let previousBodyPaddingRight = '';
let isApplied = false;

const preventTouchMove = (e: Event) => {
    e.preventDefault();
};

const applyBodyLock = () => {
    if (!isBrowserContext() || isApplied) {
        return;
    }

    const body = document.body;
    const docEl = document.documentElement;
    if (!body || !docEl) {
        return;
    }

    // сохраняем текущую позицию скролла
    savedScrollY = window.scrollY || window.pageYOffset || 0;

    // сохраняем все предыдущие стили
    previousBodyPosition = body.style.position;
    previousBodyTop = body.style.top;
    previousBodyWidth = body.style.width;
    previousBodyPaddingRight = body.style.paddingRight;

    // превентим шифт
    const scrollbarWidth = window.innerWidth - docEl.clientWidth;
    if (0 < scrollbarWidth) {
        body.style.paddingRight = `${scrollbarWidth}px`;
    }

    // блокируем скролл
    body.style.position = 'fixed';
    body.style.top = `-${savedScrollY}px`;
    body.style.width = '100%';

    document.addEventListener('touchmove', preventTouchMove, {passive: false});
    isApplied = true;
};

const removeBodyLock = () => {
    if (!isBrowserContext() || !isApplied) {
        return;
    }

    const body = document.body;
    if (body) {
        // возвращаем сохранённые стили
        body.style.position = previousBodyPosition;
        body.style.top = previousBodyTop;
        body.style.width = previousBodyWidth;
        body.style.paddingRight = previousBodyPaddingRight;
    }

    document.removeEventListener('touchmove', preventTouchMove);
    isApplied = false;

    // восстанавливаем сохранённую позицию скролла
    window.scrollTo(0, savedScrollY);
};

export const useTouchMoveDisable = () => {
    useEffect(() => {
        if (!isBrowserContext()) {
            return;
        }

        activeLocks += 1;
        if (1 === activeLocks) {
            applyBodyLock();
        }

        // eslint-disable-next-line consistent-return
        return () => {
            activeLocks = Math.max(0, activeLocks - 1);
            if (0 === activeLocks) {
                removeBodyLock();
            }
        };
    }, []);
};
